import CodingSystems from "../../../../../constants/CodingSystems";
import { createCodeableConcept } from "../../../../../utils/DataUtils";
import { renderFamilyHistoryEntry } from "./FamilyHistoryRenderer";
import FamilyHistoryFormNew from "./forms/FamilyHistoryForm-new";
import GynaecologicalHistoryForm from "./forms/GynaecologicalHistoryForm";
import HospitalizationHistoryForm from "./forms/HospitalizationHistoryForm";
import MedicalHistoryForm from "./forms/MedicalHistoryForm";
import SexualHistoryForm from "./forms/SexualHistoryForm";
import SocialHistoryForm from "./forms/SocialHistoryForm";
import SurgicalHistoryForm from "./forms/SurgicalHistoryForm";
import { renderHospitalizationHistoryEntry } from "./HospitalizationHistoryRenderer";
import { renderMedicalHistoryEntry } from "./MedicalHistoryRenderer";
import { renderSexualHistoryEntry } from "./sexualHistoryRenderer";
import { renderSocialHistoryEntry } from "./SocialHistoryRenderer";
import { renderSurgicalHistoryEntry } from "./SurgicalHisotryRenderer";

export const SOCIAL_HISTORY_QUESTIONNAIRE_CODE = "29762-2";

export const historyRenderHelpers = {
  medical: renderMedicalHistoryEntry,
  family: renderFamilyHistoryEntry,
  hospitalization: renderHospitalizationHistoryEntry,
  surgical: renderSurgicalHistoryEntry,
  social: renderSocialHistoryEntry,
  sexual: renderSexualHistoryEntry,
  gynaecological: renderSexualHistoryEntry,
};

export const historyForms = {
  medical: MedicalHistoryForm,
  family: FamilyHistoryFormNew,
  hospitalization: HospitalizationHistoryForm,
  surgical: SurgicalHistoryForm,
  social: SocialHistoryForm,
  sexual: SexualHistoryForm,
  gynaecological: GynaecologicalHistoryForm,
};

export const historyTypes = {
  medical: "Medical Condition",
  family: "Family Condition",
  hospitalization: "Hospitalization",
  surgical: "Past Surgery",
  social: "Social History",
  sexual: "Sexual History",
  gynaecological: "Gynaecological History",
};

export const emptyHistoryItems = {
  family: (patientReference) => {
    const familymemberHistory = {
      patient: patientReference,
      status: "partial",
    };
    return familymemberHistory;
  },
  medical: (patientReference) => {
    return {
      subject: patientReference,

      category: createCodeableConcept(
        CodingSystems.CONDITION_CATEGORY,
        "problem-list-item",
        "Problem List Item",
      ),
      verificationStatus: createCodeableConcept(
        CodingSystems.CONDITION_VERIFICATION_STATUS,
        "unconfirmed",
        "Unconfirmed",
      ),
      onset: {
        code: "a",
        unit: "Years",
      },
      clinicalStatus: createCodeableConcept(
        CodingSystems.CONDITION_CLINICAL_STATUS,
        "active",
        "Active",
      ),
      severity: createCodeableConcept(
        CodingSystems.CONDITION_SEVERITY,
        "moderate",
        "Moderate",
      ),
    };
  },
  hospitalization: (patientReference) => {
    const hospitalizationEncounter = {
      subject: patientReference,
      status: "finished",
      class: {
        system: CodingSystems.ENCOUNTER_CLASS,
        code: "IMP",
        display: "Inpatient Encounter",
      },
      length: {
        code: "d",
        system: "http://unitsofmeasure.org",
        unit: "Day(s)",
      },
      serviceType: createCodeableConcept(
        CodingSystems.ENCOUNTER_SERVICE_TYPE,
        "361",
        "Hospital Services",
      ),
    };
    return hospitalizationEncounter;
  },
  surgical: (patientReference) => {
    const surgicalProcedure = {
      subject: patientReference,
      category: createCodeableConcept(
        CodingSystems.PROCEDURE_CATEGORY,
        "387713003",
        "Surgical procedure",
      ),
      status: "completed",
      outcome: createCodeableConcept(
        CodingSystems.PROCEDURE_OUTCOMES,
        "385669000",
        "Successful",
      ),
      surgicalHistory: true,
    };
    return surgicalProcedure;
  },
  social: (patientReference) => {
    const socialHistoryResponse = {
      subject: patientReference,
      patient: patientReference,
      status: "completed",
      item: [],
      text: "",
    };
    return socialHistoryResponse;
  },
  sexual: (patientReference) => ({
    subject: patientReference,
    patient: patientReference,
    status: "in-progress",
    item: [],
  }),
  gynaecological: (patientReference) => ({
    subject: patientReference,
    patient: patientReference,
    status: "in-progress",
    item: [],
  }),
  reviewOfSystems: (patientReference) => {
    const reviewOfSystemsResponse = {
      subject: patientReference,
      patient: patientReference,
      status: "in-progress",
      item: [],
    };
    return reviewOfSystemsResponse;
  },
};
